import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LookbookPage() {
  const [lookbook, setLookbook] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLookbook();
  }, []);

  const fetchLookbook = async () => {
    try {
      const response = await axios.get(`${API}/lookbook`);
      setLookbook(response.data);
    } catch (error) {
      console.error('Failed to fetch lookbook:', error);
    } finally {
      setLoading(false);
    }
  };

  const images = [
    {
      src: 'https://images.unsplash.com/photo-1531035787806-3b47c2fad356?auto=format&fit=crop&w=1200&q=80',
      title: 'Urban Streets',
      description: 'Where concrete meets style'
    },
    {
      src: 'https://images.unsplash.com/photo-1663518756516-5e8ce39e412f?auto=format&fit=crop&w=1200&q=80',
      title: 'Family Vibes',
      description: 'Streetwear for every generation'
    },
    {
      src: 'https://images.unsplash.com/photo-1611618951877-1d8d1ccf1899?auto=format&fit=crop&w=1200&q=80',
      title: 'Night Moves',
      description: 'After dark essentials'
    },
    {
      src: 'https://images.unsplash.com/photo-1624816804260-65ea43f9615e?auto=format&fit=crop&w=1200&q=80',
      title: 'Street Culture',
      description: 'Express yourself'
    },
    {
      src: 'https://images.unsplash.com/photo-1704823824306-f012e232e445?auto=format&fit=crop&w=1200&q=80',
      title: 'Bold Statements',
      description: 'Make your mark'
    },
    {
      src: 'https://images.unsplash.com/photo-1556821840-3a63f95609a7?auto=format&fit=crop&w=1200&q=80',
      title: 'Comfort Zone',
      description: 'Premium quality, everyday wear'
    }
  ];

  return (
    <div className="pt-24 md:pt-28 min-h-screen" data-testid="lookbook-page">
      <div className="container-custom">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-[#FF3B30] uppercase text-xs tracking-widest">Editorial</span>
          <h1 className="font-['Syne'] text-4xl md:text-6xl font-bold mt-2">Lookbook</h1>
          <p className="text-muted-foreground mt-4 max-w-lg mx-auto">
            Explore our latest collection through the lens of urban culture and family style
          </p>
        </div>

        {/* Grid Layout */}
        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {[...Array(6)].map((_, i) => (
              <div key={i} className={`bg-neutral-900 animate-pulse ${i === 0 || i === 3 ? 'md:col-span-2 aspect-[2/1]' : 'aspect-[4/5]'}`} />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {images.map((image, idx) => (
              <div 
                key={idx}
                className={`group relative overflow-hidden border border-neutral-800 ${
                  idx === 0 || idx === 3 ? 'md:col-span-2 aspect-[2/1]' : 'aspect-[4/5]'
                }`}
                data-testid={`lookbook-image-${idx}`}
              >
                <img
                  src={image.src}
                  alt={image.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="absolute bottom-0 left-0 right-0 p-8 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <h3 className="font-['Syne'] text-2xl font-bold mb-2">{image.title}</h3>
                  <p className="text-muted-foreground">{image.description}</p>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Quote Section */}
        <div className="my-24 text-center border border-neutral-800 p-12 md:p-20">
          <blockquote className="font-['Syne'] text-2xl md:text-4xl font-bold mb-6">
            "Style has no age limit. We dress the whole family in confidence."
          </blockquote>
          <p className="text-muted-foreground uppercase text-xs tracking-widest">
            — LostNFound860
          </p>
        </div>
      </div>
    </div>
  );
}
